/* unplugin-vue-components disabled */import { render } from "./LogicalReasoning2DImg.vue?vue&type=template&id=15c3154a&scoped=true"
import script from "./LogicalReasoning2DImg.vue?vue&type=script&lang=js"
export * from "./LogicalReasoning2DImg.vue?vue&type=script&lang=js"

import "./LogicalReasoning2DImg.vue?vue&type=style&index=0&id=15c3154a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c3154a"]])

export default __exports__